import makeStyles from 'e100-react-components/lib/styles/makeStyles';

export const useStyles = makeStyles(({ spacing, typography }) => ({
  container: {
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    minHeight: spacing(6.5)
  },
  icon: {
    display: 'block'
  },
  iconContainer: {
    width: spacing(5)
  },
  checkboxContainer: {
    width: '100%'
  },
  titleRoot: {
    fontWeight: typography.subtitle1.fontWeight
  }
}));
